import React from 'react';
import { Typography, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import PaymentIcon from '@mui/icons-material/Payment';
import SecurityIcon from '@mui/icons-material/Security';

const Settings = () => {
  const settingsSections = [
    {
      icon: <PersonIcon />,
      title: "Profile Settings",
      description: "Manage your personal information, contact details, and account preferences."
    },
    {
      icon: <GroupIcon />,
      title: "User Management",
      description: "Add, remove, and manage user access and permissions for your organization."
    },
    {
      icon: <PaymentIcon />,
      title: "Billing and Payment",
      description: "View and manage your subscription, payment methods, and billing history."
    },
    {
      icon: <SecurityIcon />,
      title: "Security Settings",
      description: "Configure security options, including password policies and two-factor authentication."
    }
  ];

  return (
    <Paper elevation={0}>
      <Typography variant="h4" gutterBottom>Settings Overview</Typography>
      <Typography paragraph>
        The Settings section of AI Talker provides you with comprehensive control over your account, 
        user management, billing, and security. Here you can customize various aspects of your AI Talker 
        experience to best suit your organization's needs.
      </Typography>

      <List>
        {settingsSections.map((section, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              {section.icon}
            </ListItemIcon>
            <ListItemText 
              primary={section.title}
              secondary={section.description}
            />
          </ListItem>
        ))}
      </List>

      <Typography variant="h6" style={{ marginTop: '20px' }}>Managing Your Settings:</Typography>
      <Typography paragraph>
        1. Navigate to the specific settings area you wish to modify.
      </Typography>
      <Typography paragraph>
        2. Review the current settings and make any necessary changes.
      </Typography>
      <Typography paragraph>
        3. Save your changes - most settings take effect immediately.
      </Typography>
      <Typography paragraph>
        4. Regularly review your settings to ensure they align with your current needs and security requirements.
      </Typography>

      <Typography paragraph style={{ marginTop: '20px' }}>
        Remember, proper configuration of your settings is crucial for maintaining the security and 
        efficiency of your AI Talker implementation. If you need any assistance with configuring your 
        settings, our support team is always available to help.
      </Typography>
    </Paper>
  );
};

export default Settings;
